import app from './app';
import user from './user';
import location from './location';
import prQuickContinuation from './prQuickContinuation';
import medgptWlys from './medgpt_wlys';

export default {
  app,
  user,
  location,
  prQuickContinuation,
  medgptWlys,
};
